import { gql } from '@/__generated__';

const CREATE_SMA_DEVICE_METRIC = gql(`#graphql
  mutation SetupSMAScheduledReportConfiguration($input: SetupScheduledReportConfigurationInput!) {
    setupSMAScheduledReportConfiguration(input: $input) {
      device {
        id
      }
      success
    }
  }
`);

export default CREATE_SMA_DEVICE_METRIC;
